import { render, staticRenderFns } from "./FarmDetails.vue?vue&type=template&id=e498e9cc&scoped=true&"
import script from "./FarmDetails.vue?vue&type=script&lang=ts&"
export * from "./FarmDetails.vue?vue&type=script&lang=ts&"
import style0 from "./FarmDetails.vue?vue&type=style&index=0&id=e498e9cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e498e9cc",
  null
  
)

export default component.exports